import { APP_CONSTANTS } from '../constants';
import Logger from '../lib/logger';
class SessionStorageService {
  set(key, value) {
    try {
      if (key === APP_CONSTANTS) {
        // encode to handle any potential unicode/special characters, then convert to base64
        const encoded = btoa(encodeURIComponent(JSON.stringify(value)));
        sessionStorage.setItem(key, encoded);
      } else {
        sessionStorage.setItem(key, value);
      }
    } catch (e) {
      Logger.error('SessionStorageService set(key, value) error', e);
      throw e;
    }
  }

  get(key) {
    const value = sessionStorage.getItem(key);
    try {
      if (value && key === APP_CONSTANTS) {
        try {
          // decode base64 then decode URI encoding
          return JSON.parse(decodeURIComponent(atob(value)));
        } catch (e) {
          Logger.error('SessionStorageService get error, deleting key appConstants');
          // if decode fails, remove the invalid data.
          // App.js/AppHeader.js will refetch the data
          sessionStorage.removeItem(key);
          return null;
        }
      }
    } catch (e) {
      Logger.error('SessionStorageService get(key) error', e);
      throw e;
    }

    return value;
  }

  remove(key) {
    sessionStorage.removeItem(key);
  }
}

export default new SessionStorageService();
